import React from 'react';
import {AiOutlineHeart} from 'react-icons/ai';
import {RxVideo} from 'react-icons/rx';
import {AiOutlineStar} from 'react-icons/ai';
import {AiFillStar} from 'react-icons/ai';
import sat from '../images/sat...png';
import waec from '../images/waec.2..jpg';
import jamb from '../images/Official_JAMB_logo.png';
import neco from '../images/Neco_official_banner.jpg';

import '../styles/home.css'

const PastQuestion = () => {
  return (
     <div className='fiveth_section'>
    <div className='pastq'>
     <img src={waec} alt=''/>
     <h3> Waec Past Question</h3>
     <div className='down'>
     
     <span>
      <i><RxVideo/></i>
         <p>Subjects</p></span>
      <span>   <i> <AiOutlineHeart/></i>
         <p>200+ Students</p> </span>
         </div>
     <hr></hr>
    <div className='down'>
        <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
       
        <a href='/waec'>
        <button>Read</button></a>
        </div>
 </div>

    <div className='pastq'>
        <img src={jamb} alt=''/>
      <h3> Jamb Past Question</h3>
      <div className='down'>
     
     <span>
      <i><RxVideo/></i>
         <p>Subjects</p></span>
      <span>   <i> <AiOutlineHeart/></i>
         <p>200+ Students</p> </span>
         </div>
     <hr></hr>
    <div className='down'>
        <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
       
       <a href='/jamb'>
        <button>Read</button></a>
        </div>
    </div>
    <div className='pastq'>
        <img src={neco} alt=''/>
      <h3> Neco Past Question</h3>
      <div className='down'>
     
     <span>
      <i><RxVideo/></i>
         <p>Subjects</p></span>
      <span>   <i> <AiOutlineHeart/></i>
         <p>200+ Students</p> </span>
         </div>
     <hr></hr>
    <div className='down'>
        <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
        <a href='/neco'>
                 <button>Read</button></a>
        </div>
    </div>


    <div className='pastq'>
        <img src={sat} alt=''/>
     <h3> Sat Past Question</h3>
     <div className='down'>
     
     <span>
      <i><RxVideo/></i>
         <p>Subjects</p></span>
      <span>   <i> <AiOutlineHeart/></i>
         <p>200+ Students</p> </span>
         </div>
     <hr></hr>
    <div className='down'>
        <span><i className='yellow'> <AiFillStar/><AiFillStar/><AiFillStar/><AiFillStar/><AiOutlineStar/></i> <p>Reviews</p> </span>
        <button>Read</button>
        </div>
    </div>
</div>

  )
}

export default PastQuestion